//include 8
jQuery(function(){

    window.pixelpoint.loader = {
        show(){
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.loader+':global-loader:show');
        },
        hide(){
            window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.loader+':global-loader:hide');
        }
    }

    $("body").on("click","[data-display-global-loader]",function(){
        window.pixelpoint.pubSub.publish(window.pixelpoint.pubSub.events.loader+':global-loader:show');
    });
});